<div class="news" (click)="visitNewsSource(config.sourceLink)">
  <div class="image-container">
    <img *ngIf="imagePath" [src]="imagePath">
  </div>
  <div class="content" notranslate>
    <h5>{{config.title}}</h5>
    <a (click)="visitNewsSource(config.sourceLink)"><span class="caption">{{config.description}}</span></a>
  </div>
</div>
